import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import type { MetricRow } from '../types';

interface Props {
  rows: MetricRow[];
}

function formatUtcTick(ts: number): string {
  const d = new Date(ts * 1000);
  const hh = String(d.getUTCHours()).padStart(2, '0');
  const mm = String(d.getUTCMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

export function TrafficChart({ rows }: Props) {
  // Recharts expects ascending x-axis; our API returns DESC.
  const data = [...rows].sort((a, b) => a.bucket_ts - b.bucket_ts);

  return (
    <section className="traffic-chart" aria-label="traffic-chart">
      <h2>流量趨勢(UTC)</h2>
      <ResponsiveContainer width="100%" height={320}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="bucket_ts"
            tickFormatter={formatUtcTick}
            minTickGap={40}
          />
          <YAxis />
          <Tooltip labelFormatter={(v: number) => formatUtcTick(v) + ' UTC'} />
          <Legend />
          <Line
            type="monotone"
            dataKey="total_requests"
            stroke="#2563eb"
            dot={false}
            name="Total"
          />
          <Line
            type="monotone"
            dataKey="cache_hits"
            stroke="#16a34a"
            dot={false}
            name="Cache hits"
          />
          <Line
            type="monotone"
            dataKey="status_5xx"
            stroke="#dc2626"
            dot={false}
            name="5xx"
          />
          <Line
            type="monotone"
            dataKey="bot_requests"
            stroke="#f59e0b"
            dot={false}
            name="Bots"
          />
        </LineChart>
      </ResponsiveContainer>
    </section>
  );
}
